<template>
  <div :id="this.id"
       class="sitebuilder-element-container card big-is-receiver"
       element="PlaceMenuComponent"
       :data-hide-desktop="!this.internal_config.showDesktop"
       :data-hide-mobile="!this.internal_config.showMobile"
       :style="style()">

    <div class="card-header" :id="'heading'+this.id" @click="collapseThis($event)" v-bind:style="{
        background: background,
        borderRadius: radius,
        height : height,
        border: '0 !important'
        }">
      <h5 class="mb-0 clean-text-css h-100">
        <button class="btn btn-link w-100 h-100 icon-place desktop-element big-menu-text" :style="textStyle()">
          {{internal_config.text}}
        </button>
        <button class="btn btn-link w-100 h-100 icon-place  mobile-element big-menu-text" :style="textStyleMobile()">
          {{internal_config.text}}
        </button>
      </h5>
    </div>

    <div :id="'place-menu-'+this.id" class="place-menu-collapse card-body big-menu-place-childs" v-bind:style="{
         borderRadius: radiusContainer,
        background: backgroundContainer,
        left:leftContainer,
        top:height,
        height : heightContainer,
        width : widthContainer,
        border : borderContainer
        }">
      <div
        :class="'sitebuilder-element-receiver real-place big-is-receiver '  + (this.internal_config.widthContainerFull ? 'container' : '')">
        <component v-for="(element,index) in elements" :is="element.name" :config="element.config" :key="index"
                   :device="device"
                   :is_popup="is_popup"
                   :id="element.id" :height_start="index" :preview="preview" :childs="element.childs" ></component>
      </div>
    </div>
  </div>
</template>

<script>

  import Data from './Model';

  export default {
    name: 'PlaceMenuComponent',
    props: ['config', 'childs', 'height_start', 'device', 'id', 'preview','is_popup'],
    components: {
      Data
    },
    computed: {
      height() {
        return this.internal_config.height;
      },
      border() {
        return this.internal_config.border;
      },
      radius() {
        return this.internal_config.borderRadius;
      },
      background() {
        return this.internal_config.backgroundColor;
      },
      heightContainer() {
        return this.internal_config.heightContainer;
      },
      leftContainer() {
        if (this.internal_config.widthContainerFull) {

          let rect = document.getElementById(this.id).getBoundingClientRect();
          let docEl = document.documentElement;

          return (rect.left + (window.pageXOffset || docEl.scrollLeft || 0)) * -1 + 'px';
        }

        return this.internal_config.leftContainer;
      },
      widthContainer() {

        if (this.internal_config.widthContainerFull) {
          return document.getElementById('editor-content').getBoundingClientRect().width + 'px';
        }

        return this.internal_config.widthContainer;
      },
      borderContainer() {
        return this.internal_config.borderContainer;
      },
      radiusContainer() {
        return this.internal_config.borderRadiusContainer;
      },
      backgroundContainer() {
        return this.internal_config.backgroundColorContainer;
      },
    },
    data() {
      return Data.data();
    },
    methods: {

      collapseThis(e) {
        this.$root.$emit('focusElement', this);
        this.$root.$emit('handlerElement', this);

        e.stopPropagation();
        e.preventDefault();

        $('.place-menu-collapse:not(#place-menu-' + this.id)
          .hide();

        $('.big-menu-text').removeClass('selected');
        $('.zindexBig').removeClass('zindexBig');

        let elem = $('#place-menu-' + this.id);
        if (elem.is(":visible")) {
          elem.hide();
          document.getElementById('page-mask').hidden = true;
        } else {
          document.getElementById('page-mask').hidden = false;
          elem.show().parents('.big-is-receiver.card').find('.big-menu-text').addClass('selected');

          elem.show().parents('[element="GroupMenuComponent"]').addClass('zindexBig');

          document.body.style.setProperty('--big-menu-item-background--selected', this.internal_config.backgroundColorSelected);
          document.body.style.setProperty('--big-menu-item-color--selected', this.internal_config.textColorSelected);
        }

      },
      style() {
        return `left:  ${this.internal_config.left};
                top: ${this.internal_config.top};
                padding-top: ${this.internal_config.paddingTop};
                padding-left: ${this.internal_config.paddingLeft};
                padding-right: ${this.internal_config.paddingRight};
                padding-bottom: ${this.internal_config.paddingBottom};
                z-index: ${this.internal_config.zIndex};
                width: ${this.internal_config.width};
                max-width: ${this.internal_config.maxWidth};
                border: 0 !important;
                margin: 0 auto;`;
      },
      build() {

        this.buildIcon();
        $('.place-menu-collapse').hide();

        this.internal_config.leftContainer = (document.getElementById(this.id).offsetLeft * -1) + 'px';

        let vm = this;
        this.$el.addEventListener('mouseover', function () {
          document.body.style.setProperty('--big-menu-item-background--hover', vm.internal_config.backgroundColorHover);
          document.body.style.setProperty('--big-menu-item-color--hover', vm.internal_config.textColorHover);
        });

        // this.$el.addEventListener('mouseout', function () {
        //   let elem = $('#place-menu-' + vm.id);
        //   if (elem.is(":visible")) {
        //     elem.hide();
        //     elem.parents('.big-is-receiver.card').find('.big-menu-text').addClass('selected');
        //   }
        // });
      },

      textStyle() {

        if (typeof this.internal_config.textStyle == 'undefined') {
          this.internal_config.textStyle = {
            'family': 'arial, helvetica, sans-serif',
            'size': '15px',
            'sizeMobile': '15px',
            'color': 'White',
            'align': 'center',
            'weight': '700',
            'style': 'initial',
            'stroke': 'none'
          }
        }
        return {
          fontFamily: this.internal_config.textStyle.family,
          fontSize: this.internal_config.textStyle.size + ' !important',
          textAlign: this.internal_config.textStyle.align,
          fontWeight: this.internal_config.textStyle.weight,
          fontStyle: this.internal_config.textStyle.style,
          textDecoration: this.internal_config.textStyle.stroke,
          color: this.internal_config.textStyle.color,
          border: this.internal_config.border + ' !important',
          borderRadius: this.internal_config.borderRadius,
        };
      },
      textStyleMobile() {

        if (typeof this.internal_config.textStyle == 'undefined') {
          this.internal_config.textStyle = {
            'family': 'arial, helvetica, sans-serif',
            'size': '15px',
            'sizeMobile': '15px',
            'color': 'White',
            'align': 'center',
            'weight': '700',
            'style': 'initial',
            'stroke': 'none'
          }
        }

        return {
          fontFamily: this.internal_config.textStyle.family,
          fontSize: this.internal_config.textStyle.sizeMobile + ' !important',
          textAlign: this.internal_config.textStyle.align,
          fontWeight: this.internal_config.textStyle.weight,
          fontStyle: this.internal_config.textStyle.style,
          textDecoration: this.internal_config.textStyle.stroke,
          color: this.internal_config.textStyle.color,
          border: this.internal_config.border + ' !important',
          borderRadius: this.internal_config.borderRadius,
        };
      },
      buildIcon: function () {
        $(this.$el).find('i').detach();

        if (this.internal_config.icon !== '') {
          if (this.internal_config.iconPosition === 'left') {
            $('<i>').addClass('mdi ' + this.internal_config.icon).prependTo($(this.$el).find('.icon-place').get(0));
            $('<i>').addClass('mdi ' + this.internal_config.icon).prependTo($(this.$el).find('.icon-place').get(1));
          }
          if (this.internal_config.iconPosition === 'right') {
            $('<i>').addClass('mdi ' + this.internal_config.icon).appendTo($(this.$el).find('.icon-place').get(0));
            $('<i>').addClass('mdi ' + this.internal_config.icon).appendTo($(this.$el).find('.icon-place').get(1));
          }
        }
      },
    },
    mounted() {

      let device, childs, id, config;
      ({device, childs, id, config} = this.$props);

      if (typeof config.backgroundColor === 'undefined') {
        config.backgroundColor = '#FFFFFF';
      }
      this.internal_config = config;
      this.device = device;

      if (typeof childs === 'undefined') {
        childs = [];
        this.internal_config.childs = [];
      }

      if (typeof id !== 'undefined') {
        this.id = id;
      }

      let objIds = [];
      $('[id]').each(function () {
        var ids = $('[id="' + this.id + '"]');
        if (ids.length > 1 && ids[0] == this && parseInt(this.id))
          objIds.push(this.id);
      });

      if (objIds.includes(this.id)) {
        let newId = Date.now() + parseInt(Math.random() * 10000);
        this.id = newId;

        childs.forEach((el, index) => {
          try {
            childs[index].config.parent_id = newId;
          } catch (e) {
          }
        });

        this.$refs.elem.id = newId;
      }

      this.elements = childs.sort((a, b) => (a.config.order_mobile > b.config.order_mobile) ? 1 : ((b.config.order_mobile > a.config.order_mobile) ? -1 : 0));

      // this.internal_config = window.mergeRecursive(this.props, this.$props.config);
      let internal_config = window.mergeRecursive(this.props, this.$props.config);
      this.internal_config = {...internal_config, ...this.internal_config};


      this.build();

    }
  }

</script>
<style lang="scss" scoped>

  .card-body {
    position: relative;
  }

  .sitebuilder-element-container.card {
    height: auto !important;
    width: 100% !important;
    top: 0 !important;
    left: 0 !important;
    position: relative;
    background-color: transparent !important;

    .real-place{
      height: 100%;
    }
  }

  [data-device="tablet"],
  [data-device="mobile"] {

    .big-menu-place-childs,
    .real-place {
      height: auto !important;
      width: 100% !important;
      top: 0 !important;
      left: 0 !important;
    }

    .card-header{
      height: auto !important;
    }

    .mobile-element.big-menu-text{
      display: block !important;
    }
  }

  .card-header {
    padding: 0 !important;
  }

  .place-menu-collapse {
    position: relative;
  }

  [data-device="desktop"] {
    .big-menu-place-childs {
      position: absolute;
      z-index: 99 !important;

      .real-place {
        position: relative;
      }
    }
  }

  .big-menu-text {

    display: block;

    &:hover {
      background: var(--big-menu-item-background--hover);
      color: var(--big-menu-item-color--hover) !important;
    }

    &.selected {
      background: var(--big-menu-item-background--selected);
      color: var(--big-menu-item-color--selected) !important;
    }
  }

  .change-place-item-blue {
    display: none;
  }

  [data-device="desktop"] {

    .desktop-element.big-menu-text{
      display: block !important;
    }

    [element="GroupMenuComponent"] {


      .change-place-item-blue {
        display: block;
      }

      /*.change-place-item-blue-prev:first-of-type,*/
      /*.change-place-item-blue-next:last-of-type {*/
      /*  display: none;*/
      /*}*/

    }

  }


</style>
